export enum LabelConfigurationOption {
  CORE_NUTRIENTS = "nutrients.core",
  VOLUNTARY_NUTRIENTS = "nutrients.voluntary",
  COMBINED_VOLUNTARY_NUTRIENTS = "nutrients.voluntary.no-divider",
  SUPPLEMENT_NUTRIENTS = "nutrients.supplement",
  CUSTOM_NUTRIENTS = "nutrients.client-provided",
  SUGAR_ALCOHOLS_TOGGLE = "nutrients.sugarAlcohols",
  MONO_POLY_TOGGLE = "nutrients.mono-poly",
  OMEGA_3_6_TOGGLE = "nutrients.omega-3-6",

  DIMENSIONS_WIDTH = "dimensions.width",
  RECIPES_AND_UNIT_ANY_QUANTITY = "recipes.arbitrary",
  RECIPES_AND_UNIT_TWO = "recipes.two",
  VOLUNTARY_NUTRIENT_SIDE_BY_SIDE = "nutrients.display.side-by-side",
  CALORIES_449_TEXT = "calories.449.text",
  SHOW_PROTEIN_DV = "show.protein-DV",

  ENABLE_FSIS_MODE = "enable.FSIS.Mode",

  CANNABIS_INCL_THC_IMG = "cannabis.incl.thc-img",

  USE_CONDENSED_FONT = "font.condensed",
  USE_INLINE_FOOTNOTE = "footnote.inline",
  ENABLE_CONDENSED_FORMAT = "format.condensed",

  SHOW_SALT_FOOTNOTE = "uk.show.salt-footnote",
  SHOW_RI_COLUMN = "uk.show.ri-column",
  SHOW_PER_SERVING_ANALYSIS = "uk.show.per-serving-analysis",
  APPLY_TRAFFIC_LIGHT_COLOR = "uk.bop.traffic-light-color",
  SHOW_TEXT_INDICATORS = "uk.fop.show-text-indicators",
}